import { nanoid } from "@reduxjs/toolkit";
import { STATUS_COLORS, SYSTEM_SENDER } from "../../../../constant";

export const getStatusColor = (status) => {
  return STATUS_COLORS[status] ?? "#64748b";
};

export const createMessagePayload = ({
  selectedChat,
  user,
  message,
  message_type = "text",
  is_bot = false,
}) => {
  const clientMessageId = nanoid();
  const sentAt = new Date().toUTCString();

  const basePayload = {
    clientMessageId,
    conversation_id: selectedChat.id,
    sender_id: is_bot ? null : user.user_id,
    content: message.trim(),
    sender_type: is_bot ? "system" : "user",
    message_type,
  };

  const tempMessage = {
    ...basePayload,
    id: clientMessageId,
    tenant_id: selectedChat?.tenant_id,
    message_type,
    sent_at: sentAt,
    sender: is_bot
      ? SYSTEM_SENDER
      : {
          id: user.user_id,
          email: user.email,
          avatar: user.avatar_url,
          first_name: user.first_name,
          last_name: user.last_name,
        },
  };

  return {
    action: "sendMessage",
    data: basePayload,
    tempMessage,
  };
};

export const createFilesMessagePayload = ({
  selectedChat,
  user,
  files = [],
}) => {
  return files?.map((fileItem) => {
    const {
      id,
      file,
      filename,
      file_size_bytes,
      mime_type,
      message = "",
    } = fileItem;

    // Reuse text payload creator per file
    const base = createMessagePayload({
      selectedChat,
      user,
      message,
      message_type: "file",
    });

    const attachment = {
      id,
      filename,
      file_size_bytes,
      mime_type,
      storage_url: null,
    };

    return {
      action: base.action,
      data: {
        ...base.data,
        ...attachment,
      },
      tempMessage: {
        ...base.tempMessage,
        message_attachment: {
          ...attachment,
          file,
        },
      },
    };
  });
};

export const getChatMembers = (c) => [
  ...(c?.customers || []),
  ...(c?.members || []),
  SYSTEM_SENDER
];
